"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const ErrorMessage = ({ error }) => {
    // const { formatMessage } = useFormatter();
    // // eslint-disable-next-line @typescript-eslint/no-explicit-any
    // const { id, values }: { id: string; values: any } = (() => {
    //   const message = error.message;
    //   if (typeof message === "string") {
    //     return { id: message };
    //   } else {
    //     return message;
    //   }
    // })();
    // const message = formatMessage(id, values);
    return react_1.default.createElement("span", null, error.message);
};
exports.default = ErrorMessage;
